import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Table, Spinner } from 'react-bootstrap'
import { setMainContent } from 'actions'
import moment from 'moment'
import { toast } from 'components/common/Toast'
import ReactPaginate from 'react-paginate'
import { TransactionServices } from 'services'
import { LoadingOverlay } from 'components//common/index'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { CancelAction, CancelContainer, CancelText, Container, DetailColumn, Divider, LabelColumn, Row, StatuFree, Status } from './style'
import { PaymentServices } from 'services/index'

const Subscription = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { dispatch } = props
  const [subscription, setSubscription] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getSubscription()
  }, [])

  const getSubscription = async (page) => {
    setIsLoading(true)
    const { data, error } = await PaymentServices.getSubscriptions({ })
    if (data) {
      setSubscription(data.subscription)
    }
    setIsLoading(false)
  }

  const cancelSubscription = async () => {
    const { success, error } = await PaymentServices.cancelSubscription(subscription.subscription_id)

    if (success) {
      getSubscription()
      toast.success(t('Subscription has been cancelled'))
    } else {
      toast.error(t('Failed to cancel subscription'))
    }
  }

  return (
    <div className='main-content__payment-history'>
      <div className='payment-history__container'>
        <div className='container__label'>
          {t('Subscription')}
        </div>
        {isLoading && <LoadingOverlay />}
        {
          subscription
          ?
            <Container>
              <Row>
                <LabelColumn>
                  {t('Status')}:
                </LabelColumn>
                <DetailColumn>
                  <Status danger={subscription.subscription_status !== 'Active'}>{t(subscription.subscription_status)}</Status>
                </DetailColumn>
              </Row>
              <Row>
                <LabelColumn>
                  {t('Package')}:
                </LabelColumn>
                <DetailColumn>
                  {t(subscription.package)} { subscription.has_trial ? t('with 5 Days Trial') : ''}
                </DetailColumn>
              </Row>
              <Row>
                <LabelColumn>
                  {t('Payment')}:
                </LabelColumn>
                <DetailColumn>
                  { subscription?.currency === 'EUR' ? '€' : '$'}{subscription?.amount} { subscription?.has_trial ? t('after {{currency}}{{amount}} monthly', { currency: subscription?.currency === 'EUR' ? '€' : '$', amount: subscription?.price }) : ''}
                </DetailColumn>
              </Row>
              <Row>
                <LabelColumn>
                  {t('Start date')}:
                </LabelColumn>
                <DetailColumn>
                {subscription.started_at}
                </DetailColumn>
              </Row>
              <Row>
                <LabelColumn>
                  {t('Next billing date')}:
                </LabelColumn>
                <DetailColumn>
                {subscription.ended_at}
                </DetailColumn>
              </Row>

              <Divider></Divider>

              <CancelContainer>
                <CancelText onClick={() => cancelSubscription()}>{t('Unsubscribe')}</CancelText>. {t('If you unsubscribe now you can still use your subscription until {{date}}', {date: subscription.ended_at})}
              </CancelContainer>
            </Container>
          :
            <Container>
              <Row>
                <LabelColumn>
                  {t('Status')}:
                </LabelColumn>
                <DetailColumn>
                  <StatuFree>{t('Free')}</StatuFree>
                </DetailColumn>
              </Row>
              <Divider></Divider>
            </Container>
        }
      </div>
    </div>
  )
}

export default connect(null)(Subscription)
